import { render, staticRenderFns } from "./PostComposer.vue?vue&type=template&id=a4ab8aa6"
import script from "./PostComposer.vue?vue&type=script&lang=js"
export * from "./PostComposer.vue?vue&type=script&lang=js"
import style0 from "./PostComposer.vue?vue&type=style&index=0&id=a4ab8aa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports